export default "<p>expense-summary works!</p>\n"